import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/admin/ProgramManagement.css";
import Adminmasterlayout from "../../../layouts/Adminmasterlayout/Adminmasterlayout";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import { Spinner } from "react-bootstrap";

const ProgramManagement = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [programmes, setProgrammes] = useState([]);
  const [progIdForUpdate, setProgIdForUpdate] = useState(null);
  const [progName, setProgName] = useState("");
  const [progError, setProgError] = useState("");
  const [departments, setDepartments] = useState([]);

  // FIX #2: default value ab dropdown ke placeholder option ("0") se match karta hai
  const [department, setDepartment] = useState("0");
  const [departmentError, setDepartmentError] = useState("");
  const [progDuration, setProgDuration] = useState("");
  const [progDegree, setProgDegree] = useState("Bachelor");
  const [progStatus, setProgStatus] = useState("Active");
  const [image, setImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { regExpChecker } = useContext(AppContext);
  const [imagePreview, setImagePreview] = useState(null);

  // ── Loading states (added for spinners, no existing logic changed) ──
  const [isSubmitting, setIsSubmitting] = useState(false); // Add/Update button spinner

  const resetForm = () => {
    setProgName("");
    setProgDuration("");
    setDepartment("0"); // FIX #2: reset bhi placeholder value pe
    setProgDegree("Bachelor");
    setProgStatus("Active");
    setImage(null);
    setImagePreview(null);
    setProgIdForUpdate(null);
    setProgError("");
    setDepartmentError("");
  };

  const viewAllProgramme = () => {
    axios
      .get(`${baseUrl}/admin/programme/viewAllProgramme`)
      .then((response) => {
        console.log(response.data);
        setProgrammes(response.data.programmes);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const viewAllDepartments = () => {
    axios
      .get(`${baseUrl}/admin/department/viewAllDepartments`)
      .then((response) => {
        console.log(response.data);
        setDepartments(response.data.departments);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const addProgramme = () => {
    const departmentErr = regExpChecker("department", department);
    if (departmentErr) {
      setDepartmentError(departmentErr);
      // FIX: alert bhi dikhao, taake modal scroll position se error miss na ho
      Swal.fire({
        icon: "warning",
        title: "Fix the highlighted field",
        text: departmentErr,
      });
      return;
    }

    // FIX #1: fresh computed error (progCodeError) check ho raha hai,
    // purana stale "progError" state nahi
    const progCodeError = regExpChecker("program", progName);
    if (progCodeError) {
      setProgError(progCodeError);
      // FIX: alert bhi dikhao, taake modal scroll position se error miss na ho
      Swal.fire({
        icon: "warning",
        title: "Fix the highlighted field",
        text: progCodeError,
      });
      return;
    }
    setDepartmentError("");
    setProgError("");
    if (!progName) return;

    const formData = new FormData();
    formData.append("progName", progName);
    formData.append("ngdepartment_id", department);
    formData.append("progDuration", progDuration);
    formData.append("progDegree", progDegree);
    formData.append("progStatus", progStatus);
    if (image) formData.append("image", image);

    setIsSubmitting(true);
    axios
      .post(`${baseUrl}/admin/programme/createProgramme`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          viewAllProgramme();
          resetForm();
          setShowModal(false);
          Swal.fire({
            icon: "success",
            title: "Programme Added!",
            confirmButtonText: "Okay",
          });
        } else {
          // FIX #3: backend ne success:false bheja to bhi user ko pata chale
          Swal.fire({
            icon: "error",
            title: "Could not add programme",
            text: response.data.message || "Please try again.",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        // FIX #3: request hi fail ho gayi (network/500 error) to user ko dikhaye
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text:
            error?.response?.data?.message ||
            "Could not add programme. Please try again.",
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const updateProgramme = () => {
    if (!progName) return;

    const formData = new FormData();
    formData.append("id", progIdForUpdate);
    formData.append("ngdepartment_id", department);
    formData.append("progName", progName);
    formData.append("progDuration", progDuration);
    formData.append("progDegree", progDegree);
    formData.append("progStatus", progStatus);
    if (image) formData.append("image", image);

    setIsSubmitting(true);
    axios
      .post(`${baseUrl}/admin/programme/updateProgramme`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          viewAllProgramme();
          resetForm();
          setShowModal(false);
          Swal.fire({
            icon: "success",
            title: "Programme Updated!",
            confirmButtonText: "Okay",
          });
        } else {
          // FIX #3
          Swal.fire({
            icon: "error",
            title: "Could not update programme",
            text: response.data.message || "Please try again.",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        // FIX #3
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text:
            error?.response?.data?.message ||
            "Could not update programme. Please try again.",
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  useEffect(() => {
    viewAllProgramme();
    viewAllDepartments();
  }, []);

  const handleOpenAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  const handleOpenEditModal = (prog) => {
    setProgIdForUpdate(prog.id);

    setProgName(prog.progName);

    // Department ID
    setDepartment(prog.ngdepartment_id ?? "0");

    setProgDuration(prog.progDuration);
    setProgDegree(prog.progDegree);
    setProgStatus(prog.progStatus);

    if (prog.image) {
      setImagePreview(`${baseUrlForFiles}/${prog.image}`);
    } else {
      setImagePreview(null);
    }

    setImage(null);

    setShowModal(true);
  };

  const handleCloseModal = () => {
    resetForm();
    setShowModal(false);
  };

  const handleSubmit = () => {
    if (progIdForUpdate === null) {
      addProgramme();
    } else {
      updateProgramme();
    }
  };

  return (
    <Adminmasterlayout>
      <div className="prog-container">
        <div className="prog-main">
          {/* ── Header ── */}
          <div className="prog-header">
            <div className="prog-header__content">
              <h1 className="prog-header__title">Programme Management</h1>
              <p className="prog-header__subtitle">
                Manage and organise academic programmes
              </p>
            </div>
            <button
              className="prog-btn prog-btn--primary"
              onClick={handleOpenAddModal}
            >
              + Add Programme
            </button>
          </div>

          {/* ── Table ── */}
          <div className="prog-table-container">
            <table className="prog-table">
              <thead className="prog-table__head">
                <tr>
                  <th className="prog-table__th">#</th>
                  <th className="prog-table__th">Department</th>
                  <th className="prog-table__th">Programme Name</th>
                  <th className="prog-table__th">Duration</th>
                  <th className="prog-table__th">Degree</th>
                  <th className="prog-table__th">Status</th>
                  <th className="prog-table__th">Image</th>
                  <th className="prog-table__th">Actions</th>
                </tr>
              </thead>
              <tbody className="prog-table__body">
                {programmes.length > 0 ? (
                  programmes.map((prog, i) => (
                    <tr key={prog.id} className="prog-table__row">
                      <td className="prog-table__td">{i + 1}</td>
                      <td className="prog-table__td">
                        <span
                          className={`prog-departmentid-badge prog-departmentid-badge--${prog.departmentid?.toLowerCase()}`}
                        >
                          {prog.ngdepartment?.deptName}
                        </span>
                      </td>
                      <td className="prog-table__td prog-table__td--bold">
                        {prog.progName}
                      </td>

                      <td className="prog-table__td">{prog.progDuration}</td>
                      <td className="prog-table__td">
                        <span
                          className={`prog-degree-badge prog-degree-badge--${prog.progDegree?.toLowerCase()}`}
                        >
                          {prog.progDegree}
                        </span>
                      </td>
                      <td className="prog-table__td">
                        <span
                          className={`prog-badge prog-badge--${prog.progStatus?.toLowerCase()}`}
                        >
                          {prog.progStatus}
                        </span>
                      </td>
                      <td className="prog-table__td">
                        {prog.image ? (
                          <img
                            src={`${baseUrlForFiles}/${prog.image}`}
                            alt={prog.progName}
                            className="prog-table__img"
                          />
                        ) : (
                          <div className="prog-table__img-placeholder">🖼️</div>
                        )}
                      </td>
                      <td className="prog-table__td">
                        <div className="prog-action-buttons">
                          <button
                            className="prog-toggle-btn prog-toggle-btn--edit"
                            title="Edit Programme"
                            onClick={() => handleOpenEditModal(prog)}
                          >
                            Edit
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="prog-table__row">
                    <td
                      className="prog-table__td prog-table__td--empty"
                      colSpan="8"
                    >
                      <div className="prog-empty-state">
                        <div className="prog-empty-state__icon">🎓</div>
                        <p className="prog-empty-state__text">
                          No programmes found
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ── Modal ── */}
      {showModal && (
        <div className="prog-modal">
          <div className="prog-modal__overlay" onClick={handleCloseModal} />
          <div className="prog-modal__content">
            <div className="prog-modal__header">
              <h2 className="prog-modal__title">
                {progIdForUpdate === null
                  ? "Add New Programme"
                  : "Edit Programme"}
              </h2>
              <button className="prog-modal__close" onClick={handleCloseModal}>
                ×
              </button>
            </div>

            <div className="prog-form">
              <div className="csm__form-group">
                <label className="csm__form-label">Department</label>
                <select
                  type="text"
                  className="csm__form-input"
                  placeholder="Enter department"
                  value={department}
                  onChange={(e) => {
                    setDepartment(e.target.value);
                    setDepartmentError(
                      regExpChecker("department", e.target.value),
                    );
                  }}
                >
                  <option value="0">SELECT DEPARTMENT</option>
                  {departments.map((dept) => {
                    return (
                      <option key={dept.id} value={dept.id}>
                        {dept.deptName}
                      </option>
                    );
                  })}
                </select>
                {departmentError && (
                  <p className="error-text">{departmentError}</p>
                )}
              </div>
              <div className="prog-form__group">
                <label className="prog-form__label">
                  Programme Name <span className="prog-form__req">*</span>
                </label>
                <input
                  type="text"
                  value={progName}
                  onChange={(e) => {
                    setProgName(e.target.value);
                    setProgError(regExpChecker("program", e.target.value));
                  }}
                  className="prog-form__input"
                  placeholder="e.g. BSc Computer Science"
                  required
                />
                {progError && <p className="error-text">{progError}</p>}
              </div>

              <div className="prog-form__group">
                <label className="prog-form__label">Duration</label>
                <input
                  type="text"
                  value={progDuration}
                  onChange={(e) => setProgDuration(e.target.value)}
                  className="prog-form__input"
                  placeholder="e.g. 4 Years"
                />
              </div>

              <div className="prog-form__group">
                <label className="prog-form__label">Degree Level</label>
                <select
                  value={progDegree}
                  onChange={(e) => setProgDegree(e.target.value)}
                  className="prog-form__select"
                >
                  <option value="Bachelor">Bachelor</option>
                  <option value="Master">Master</option>
                  <option value="PhD">PhD</option>
                  <option value="Diploma">Diploma</option>
                </select>
              </div>

              <div className="prog-form__group">
                <label className="prog-form__label">Status</label>
                <select
                  value={progStatus}
                  onChange={(e) => setProgStatus(e.target.value)}
                  className="prog-form__select"
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>

              <div className="prog-form__group">
                <label className="prog-form__label">Programme Image</label>

                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const selectedImage = e.target.files[0];

                    if (selectedImage) {
                      setImage(selectedImage);

                      // New selected image ka preview
                      setImagePreview(URL.createObjectURL(selectedImage));
                    }
                  }}
                  className="prog-form__input prog-form__input--file"
                />

                {imagePreview && (
                  <div style={{ marginTop: "10px" }}>
                    <img
                      src={imagePreview}
                      alt="Programme Preview"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                )}
              </div>

              <div className="prog-form__actions">
                <button
                  className="prog-btn prog-btn--secondary"
                  onClick={handleCloseModal}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                {isSubmitting ? (
                  <Spinner size="lg" />
                ) : (
                  <button
                    className="prog-btn prog-btn--primary"
                    onClick={handleSubmit}
                  >
                    {progIdForUpdate === null
                      ? "Add Programme"
                      : "Update Programme"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </Adminmasterlayout>
  );
};

export default ProgramManagement;